import { ReactNode } from 'react'
import { usePage } from '@inertiajs/react'
import { SharedProps, TeamSummary } from '../types'
import GlobalNav from './layout/GlobalNav'
import CompanyHandoff from './billing/CompanyHandoff'
import ImpersonationBanner from './layout/ImpersonationBanner'
import TeamSubNav from './layout/TeamSubNav'

interface Props {
  children: ReactNode
  team?: TeamSummary
  activeTab?: string
  actionItemCount?: number
  globalNavVariant?: 'default' | 'scorecard'
  meetingHeader?: ReactNode
}

export default function Layout({ children, team, activeTab, actionItemCount, globalNavVariant = 'default', meetingHeader }: Props) {
  const { flash, impersonation, company_payment_handoff } = usePage().props as unknown as SharedProps

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <ImpersonationBanner impersonation={impersonation} />
      <GlobalNav variant={globalNavVariant} />
      <CompanyHandoff handoff={company_payment_handoff} />
      {team && activeTab && (
        <TeamSubNav team={team} activeTab={activeTab} actionItemCount={actionItemCount} />
      )}
      {flash?.notice && (
        <div className="max-w-screen-2xl mx-auto px-6 pt-4">
          <div className="px-4 py-3 bg-[#15532E]/10 text-[#15532E] rounded-lg text-lg">{flash.notice}</div>
        </div>
      )}
      {flash?.alert && (
        <div className="max-w-screen-2xl mx-auto px-6 pt-4">
          <div className="px-4 py-3 bg-[#ED1C24]/10 text-[#ED1C24] rounded-lg text-lg">{flash.alert}</div>
        </div>
      )}
      {meetingHeader}
      <main className="max-w-screen-2xl mx-auto px-6 py-6">
        {children}
      </main>
    </div>
  )
}
